// extracted by mini-css-extract-plugin
export default {"block":"RunningLine_block__lkUCv","run":"RunningLine_run__lh0WK"};